// extracted by mini-css-extract-plugin
export default {"container":"OrganisationsPendingApplicationsPage_container__UAbe4","loaderContainer":"OrganisationsPendingApplicationsPage_loaderContainer__3lkBr"};